"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ChangeEmailForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      inProcess = _ref.inProcess;

  try {
    return /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u041D\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u043F\u043E\u0447\u0442\u044B",
      name: "email",
      disabled: inProcess
    }), /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      className: _defaultModule["default"]['description']
    }, "\u0414\u043B\u044F \u0441\u043C\u0435\u043D\u044B \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0432\u0432\u0435\u0441\u0442\u0438 \u043A\u043E\u0434 \u0438\u0437 \u043F\u0438\u0441\u044C\u043C\u0430"));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ChangeEmailForm;
exports["default"] = _default;